import {usePersonasQuery} from './usePersonasQuery';
import {usePersonasSearch} from './usePersonasSearch';
import {usePersonasTableColumns} from './usePersonasTableColumns';

export const usePersonas = (filters: Record<string, string> = {}) => {
    const {
        data: items = [],
        isLoading: loading
    } = usePersonasQuery(filters);
    const {keyword} = usePersonasSearch();
    const {columns} = usePersonasTableColumns();

    // Client-side keyword filtering against the shared store (FNP-815).
    const needle = keyword.trim()
                          .toLowerCase();

    const visibleItems = items.filter(item =>
        !needle ||
        item.name?.toLowerCase()
            .includes(needle) ||
        item.description?.toLowerCase()
            .includes(needle) ||
        (item.actionCodes ?? []).some(entry =>
            entry.actionCode.toLowerCase()
                 .includes(needle))
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
